import { Dispatch, FC, SetStateAction } from 'react'

import { OpenWebAppBanner, TransactionHistory } from './components'

import { ITransactionItem } from '@/services/wallet/getTransactions'
import { IWallet } from '@/services/wallet/getWallet'
import { isNative } from '@/utils/utils'

interface WalletProps {
  wallet: IWallet
  transactions: ITransactionItem[]
  setIsRefetchActive: Dispatch<SetStateAction<boolean>>
  isGetTransactionsLoading: boolean
  hasGetTransactionsNextPage: boolean
  fetchTransactionsNextPage: () => void
  isGetTransactionsFetching: boolean
}

export const Wallet: FC<WalletProps> = ({
  setIsRefetchActive,
  wallet,
  transactions,
  isGetTransactionsLoading,
  hasGetTransactionsNextPage,
  fetchTransactionsNextPage,
  isGetTransactionsFetching,
}) => {
  return (
    <div className="flex flex-col h-full text-left w-full mx-auto max-w-[40rem]">
      <OpenWebAppBanner />
      <TransactionHistory
        balance={isNative() ? wallet?.totalBalance : wallet?.balance}
        stakedBalance={wallet?.stakedBalance}
        setIsRefetchActive={setIsRefetchActive}
        transactions={transactions}
        isGetTransactionsLoading={isGetTransactionsLoading}
        hasGetTransactionsNextPage={hasGetTransactionsNextPage}
        fetchTransactionsNextPage={fetchTransactionsNextPage}
        isGetTransactionsFetching={isGetTransactionsFetching}
      />
    </div>
  )
}
